export default "__VITE_ASSET__TBWngP2S__"